import styled from 'styled-components'

export const AppPaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 24px;

  .ant-pagination-item,
  .ant-pagination-prev,
  .ant-pagination-next {
    border-radius: 8px !important;
    border-color: #e2e8f0;

    &:hover {
      border-color: #9cd4fc;

      a {
        color: #70aefb;
      }
    }
  }

  .ant-pagination-item-active {
    background-color: #eff8ff !important;
    border-color: #9cd4fc !important;

    a {
      color: #0f172a !important;
      font-weight: 600 !important;
    }
  }
`
